/*
舒效比的简笔画风格svg
*/
import React from 'react';
import Icon from '@ant-design/icons';

const RecopenSVG = ({ width = '1846px', height = '2037px' }) => (
    <svg
        id="_图层_1"
        data-name="图层 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 116.09 92.21"
        width={width}
        height={height}
    >
        {/* 左侧半透明背景 */}
        <path
            fill="#b5b5b6"
            opacity="0.7"
            d="M114.31,23.46l-55.68,9.44c2.32,2.04,35.17,30.57,19.56,47.01-5.85,6.16-12.58,8.83-18.76,9.23,30.82-.56,55.66-25.47,55.69-56.17,0-3.24-.27-6.42-.8-9.51Z"
        />
        <path
            fill="#b5b5b6"
            opacity="0.7"
            d="M58.22,33.04L2.46,23.31c-.54,3.1-.82,6.29-.83,9.55-.03,30.44,24.34,55.24,54.8,56.25-6.11-.46-12.43-3.3-18.2-9.39-15.61-16.5,17.75-44.74,19.98-46.69Z"
        />
        <path
            fill="#727171"
            opacity="0.7"
            d="M58.2,32.51v-.1s-.02,.02-.06,.05c-.04-.03,.4-.08,.4-.08l.17,.29c-2.2,1.89-36.04,30.87-20.43,47.12,6.22,6.47,13.09,9.21,19.63,9.31h0c.06,0,.11,0,.17,0,.06,0,.11,0,.17,0h0c6.54-.09,13.6-2.78,19.83-9.23,15.65-16.22-17.7-45.47-19.89-47.37Z"
        />

        {/* 外圈轮廓 */}
        <path
            fill="#c30d23"
            stroke="#c30d23"
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M89.4,30.41c-2.44-15.61-15.69-26.95-31.52-26.95S28.88,14.74,26.39,30.27l-3.06-.49C26.07,12.74,40.6,.38,57.88,.38s31.9,12.43,34.57,29.56l-3.06,.48Z"
        />
        <path
            fill="#c30d23"
            stroke="#c30d23"
            strokeWidth="0.75"
            strokeMiterlimit="10"
            d="M58.04,91.84C26.24,91.84,.38,65.95,.38,34.14c0-3.26,.28-6.56,.83-9.79l.42-2.45,56.42,9.72,56.43-9.68,.42,2.44c.55,3.21,.82,6.49,.82,9.75,0,31.82-25.87,57.7-57.67,57.7ZM5.73,27.63c-.26,2.16-.4,4.34-.4,6.5,0,29.09,23.65,52.75,52.72,52.75s52.72-23.66,52.72-52.75c0-2.15-.13-4.32-.39-6.47l-52.33,8.98L5.73,27.63Z"
        />

        {/* 红色指针 */}
        <path
            fill="#b81c25"
            d="M58.82,33.78l-9.69-19.24c.17-.18,.27-.41,.31-.65,.01-.08,.02-.16,.01-.24,0-.16-.04-.32-.12-.48-.11-.23-.28-.41-.49-.54-.07-.04-.14-.07-.21-.1-.15-.05-.31-.08-.47-.07-.03,0-.05,0-.08,.01l-1.01-2.01-.81-.8,.09,1.12,.95,2.08c-.33,.36-.43,.89-.21,1.36,.22,.46,.67,.72,1.15,.71l8.92,19.57,1.65-.73Z"
        />

        {/* 圆点和杆 */}
        <circle cx="69.78" cy="76.86" r="6.91" fill="#c30d23" />
        <rect
            x="62.42"
            y="34.92"
            width="1.03"
            height="33.55"
            transform="translate(-11.36 18.33) rotate(-15.22)"
            fill="#c30d23"
        />

        {/* 中心圆环 */}
        <circle cx="58.04" cy="34.2" r="2.5" fill="#9fa0a0" />
        <circle cx="58.04" cy="34.2" r="1.09" fill="#898989" />
    </svg>
);

const RecopenIcon = (props) => (
    <Icon component={(iconProps) => <RecopenSVG {...iconProps} {...props} />} />
);

export default RecopenIcon;